"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupBy = void 0;
/**
 @example groupBy(list, (a)=> a.keyOnList)
 */
var groupBy = function (list, key) {
    return list.reduce(function (result, currentValue) {
        var keyProperty = key(currentValue);
        if (result[keyProperty] === undefined) {
            result[keyProperty] = [];
        }
        result[keyProperty].push(currentValue);
        return result;
    }, {});
};
exports.groupBy = groupBy;
